import { parseMfbParts } from "../../../utils/mfbUtils";

export default function getAuthoringPreviewProps(item, typeToColorMap = {}) {
  const isMatch = item?.Type === "Match";
  const isMarkup = item?.Type === "Markup";
  const isRearrange = item?.Type === "ReArrange";

  // MATCH only → Options must be array
  const matchOptionsArray = Array.isArray(item?.Options) ? item.Options : [];

  // Extract sentence words for ReArrange
  const rearrangeWords = isRearrange
    ? (item?.Options?.[0]?.Value || "").split(" ").filter((w) => w.trim())
    : [];

  const rankingPreview = Array.isArray(item?.Options)
    ? item.Options.map((o, index) => ({
        Id: index + 1,
        Value: o.Value,
        Rationale: { Text: o.Rationale },
      }))
    : [];

  return {
    activity: {
      ...item,
      ContentId: "preview", // force preview mode everywhere
    },

    index: 0,
    total: 1,
    submitted: false,
    preview: true,

    // =======================
    // ⭐ MCMA
    // =======================
    answers: {},

    // =======================
    // ⭐ MATCH
    // =======================
    matchSelections: {},
    shuffledNames: isMatch ? matchOptionsArray.map((o) => o.Name) : [],
    shuffledValues: isMatch ? matchOptionsArray.map((o) => o.Value) : [],
    handleSelectChange: () => {},

    // =======================
    // ⭐ MFB
    // =======================
    mfbSelections: {},
    shuffledMfbOptions: parseMfbParts(item?.Options?.[0]?.Value || "").map(
      (p) => (Array.isArray(p) ? p : p)
    ),

    // =======================
    // ⭐ MARKUP
    // =======================
    markupAnswers: {},
    selectedColor: null,
    typeToColorMap: typeToColorMap,
    setMarkupAnswers: () => {},
    setSelectedColor: () => {},

    // =======================
    // ⭐ REARRANGE (FIXED)
    // =======================
    rearrangeSelections: {},
    shuffledWords: rearrangeWords,
    setShuffledWords: () => {},

    // =======================
    // ⭐ RANKING
    // =======================
    rankingSelections: rankingPreview,
    setRankingSelections: () => {}, // NO state update in preview

    // =======================
    // ⭐ IRAAB
    // =======================
    iraabAnswers: {},
    selectedIraabWord: null,
    setIraabAnswers: () => {},
    setSelectedIraabWord: () => {},

    // =======================
    // ⭐ COMMON
    // =======================
    reviewedContent: {},
    setReviewedContent: () => {},
  };
}
